import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import OfaDocument from '../ofaDocument';
import { Tooltip } from '@material-ui/core';
import { RFA_STATUS } from '../../../../utils/constant';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DocumentView = props => {
  const downloadButton = props.document.isUploaded ? /*#__PURE__*/_jsxs("button", {
    "data-id": "download",
    className: "inline-container large secondary",
    onClick: props.onDownloadClick,
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: "download"
    }), /*#__PURE__*/_jsx(Translate, {
      value: "request.documents.actions.see"
    })]
  }) : null;
  let uploadButton = /*#__PURE__*/_jsxs("button", {
    "data-id": "upload",
    className: "inline-container large secondary",
    onClick: props.onUploadClick,
    disabled: Boolean(props.disabledUploadReason),
    style: props.disabledUploadReason ? {
      pointerEvents: 'none'
    } : {},
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: "upload-document"
    }), /*#__PURE__*/_jsx(Translate, {
      value: 'request.documents.actions.upload'
    })]
  });
  uploadButton = props.disabledUploadReason ? /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "request-document-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: props.disabledUploadReason
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: uploadButton
    })
  }) : uploadButton;
  let updateButton = /*#__PURE__*/_jsxs("button", {
    "data-id": "update",
    className: "inline-container large secondary",
    onClick: props.onUploadClick,
    disabled: Boolean(props.disabledUpdateReason),
    style: props.disabledUpdateReason ? {
      pointerEvents: 'none'
    } : {},
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: "edit"
    }), /*#__PURE__*/_jsx(Translate, {
      value: 'request.documents.actions.update'
    })]
  });
  updateButton = props.disabledUpdateReason ? /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "update-document-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: props.disabledUpdateReason
    }),
    children: /*#__PURE__*/_jsx("span", {
      children: updateButton
    })
  }) : updateButton;
  const documentUploadStateText = props.document.isUploaded && props.document.isUploadedAfterRfaValidation ? /*#__PURE__*/_jsx(Translate, {
    value: 'request.documents.states.UPLOADED_AFTER_RFA_VALIDATION'
  }) : /*#__PURE__*/_jsx(Translate, {
    value: `request.documents.states.${props.document.state}`
  });
  const documentStateText = props.document.isUploaded && props.document.isUploadedAfterRfaValidation && props.document.isUpdated && props.rfaStatus === RFA_STATUS.VALIDATED ? /*#__PURE__*/_jsx(Translate, {
    value: 'request.documents.states.UPDATED_AFTER_RFA_VALIDATION'
  }) : documentUploadStateText;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: props.fromOfa ? /*#__PURE__*/_jsx(OfaDocument, {
      document: props.document,
      onDownloadClick: props.onDownloadClick
    }) : props.document && props.document.type && /*#__PURE__*/_jsxs("div", {
      className: "box border bottom",
      children: [/*#__PURE__*/_jsx("div", {
        className: "card-header font-size-l",
        children: props.document.type.label
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex-container space-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "inline-container",
          children: [/*#__PURE__*/_jsx(Icon, {
            color: props.document.isUploaded ? 'success' : 'error',
            icon: props.document.isUploaded ? 'check' : 'error'
          }), /*#__PURE__*/_jsxs("span", {
            "data-id": "document-state-text",
            children: [" ", documentStateText, " "]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "inline-container flex-shrink-0",
          children: [downloadButton, props.displayUpload && (props.document.isUploaded ? updateButton : uploadButton)]
        })]
      })]
    }, props.document.code)
  });
};
DocumentView.propTypes = {
  document: PropTypes.object,
  fromOfa: PropTypes.bool,
  rfaStatus: PropTypes.string,
  onUploadClick: PropTypes.func,
  onDownloadClick: PropTypes.func,
  displayUpload: PropTypes.bool,
  disabledUploadReason: PropTypes.string,
  disabledUpdateReason: PropTypes.string
};
export default DocumentView;